/* global I18n */

import React from "react"
import QuizModeButton from "./quiz_mode_button"
import ExamModeConfigurations from "./exam_mode_configurations"
import StudyModeConfigurations from "./study_mode_configurations"
import ReviewModeConfigurations from "./review_mode_configurations"
import ExamModeCard from "./exam_mode_card"
import StudyModeCard from "./study_mode_card"
import {use_configuration} from "./configuration_provider"

function QuizModeSelectorContent({on_click, quiz, title, cta}) {
  const {configuration} = use_configuration()
  const {quiz_mode, exam_conditions} = configuration

  return (
    <div className={
      `quiz-mode-selector
      ${exam_conditions ? "exam-conditions" : ""}`
    }>
      <h3 className="modal-title">
        {title || I18n.t("js.quiz_mode_selector.title")}
      </h3>
      <div className="modal-content">
        {["study_mode", "exam_mode", undefined].includes(quiz_mode) &&
          <div className={`quiz-modes ${quiz_mode ? "active" : ""}`}>
            <StudyModeCard
              is_selected={quiz_mode === "study_mode"}
            />
            <ExamModeCard
              is_selected={quiz_mode === "exam_mode"}
            />
          </div>}
        {quiz_mode === "study_mode" &&
          <StudyModeConfigurations quiz={quiz}/>
        }
        {quiz_mode === "exam_mode" &&
          <ExamModeConfigurations quiz={quiz}/>
        }
        {quiz_mode === "review_mode" &&
          <ReviewModeConfigurations quiz={quiz}/>
        }
      </div>
      <QuizModeButton
        text={cta}
        on_click={on_click}
      />
    </div>
  )
}

export default QuizModeSelectorContent
